import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await api.getContent();
      setContent(data || {});
    } catch (e) {
      setContent({});
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loaded, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used within ContentProvider");
  // helper: get language-aware value with fallback
  const cval = (key, lang, fallback = "") => {
    const c = ctx.content || {};
    const langKey = `${key}_${lang}`;
    if (c[langKey] !== undefined && c[langKey] !== "") return c[langKey];
    if (c[key] !== undefined && c[key] !== "") return c[key];
    return fallback;
  };
  return { ...ctx, cval };
};
